import { lazy } from 'react'
import { Route, useNavigate, useParams } from 'react-router-dom'

import { usePersonaBaseUrl } from '@/ui/hooks/usePersonaBaseUrl'

const Redirect = lazy(() => import('../../shared/pages/redirect'))

function ProfileInfoRedirect() {
  const { idClient } = useParams()
  const navigate = useNavigate()
  const redirectBaseRoute = usePersonaBaseUrl()
  navigate(`${redirectBaseRoute}/profile-info/${idClient}`)
  return <></>
}

export default function SharedRoutes() {
  return (
    <>
      <Route path={'first-access/*'} element={<Redirect />} />
      <Route
        path={'/profile-info/:idClient'}
        element={<ProfileInfoRedirect />}
      />
    </>
  )
}
